import Cookies from "js-cookie";

export const CURRENCY_COOKIE = "preferred_currency";
export const DEFAULT_CURRENCY = "USD";

export const persistPreferredCurrency = (currency) => {
  if (!currency) return;

  Cookies.remove(CURRENCY_COOKIE);
  Cookies.remove(CURRENCY_COOKIE, { path: "/" });
  Cookies.set(CURRENCY_COOKIE, currency, { path: "/", expires: 365 });
};

export const getPreferredCurrency = () =>
  Cookies.get(CURRENCY_COOKIE) || DEFAULT_CURRENCY;

export const resolveCurrencyLabel = (...values) =>
  values.find((value) => typeof value === "string" && value.trim() !== "") ||
  getPreferredCurrency();
